<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
  >
    <!-- <vs-button @click="activePrompt = true" class="w-full">Add New</vs-button> -->
    <div class="" @click="activePrompt = true">
      <feather-icon icon="PlusCircleIcon" svgClasses="h-4 w-4" />
      <span class="text-sm font-semibold ml-2">Add Questions</span>
    </div>

    <vs-prompt
      title="Add Question"
      accept-text="Save"
      accept-text1="Save1"
      button-cancel="border"
      @cancel="clearFields"
      @accept="addTodo"
      @close="clearFields"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div>
        <form>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Question</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    v-validate="'required'"
                    name="question"
                    placeholder="eg. How does adrenaline work?"
                    class="w-full"
                    v-model="taskLocal.question"
                    :color="validateForm ? 'success' : 'danger'"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Question type</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <!-- <vs-input
                    v-validate="'required'"
                    name="video title"
                    placeholder="Video title"
                    class="w-full"
                    v-model="taskLocal.video_title"
                    :color="validateForm ? 'success' : 'danger'"
                  /> -->
                  <vs-radio
                    v-model="taskLocal.type"
                    vs-value="multiple-select"
                    class="p-2"
                    >Multiple select</vs-radio
                  >
                  <vs-radio
                    v-model="taskLocal.type"
                    vs-value="single-select"
                    class="p-2"
                    >Single select</vs-radio
                  >
                  <vs-radio
                    v-model="taskLocal.type"
                    vs-value="boolean"
                    class="p-2"
                    >True/False</vs-radio
                  >
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Options</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <span>A</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input
                        v-validate="'required'"
                        name="option 1"
                        placeholder="Option 1"
                        class="w-full"
                        v-model="taskLocal.options.option_1"
                        :color="validateForm ? 'success' : 'danger'"
                      />
                    </div>
                    <!-- <div class="vx-col sm:w-1/6 w-full">
                  <span>A</span>
                </div>
                <div class="vx-col sm:w-2/6 w-full">
                    <vs-input
                      v-validate="'required'"
                      name="thumbnail"
                      placeholder="Thumbnail"
                      class="w-full"
                      v-model="taskLocal.thumbnail"
                      :color="validateForm ? 'success' : 'danger'"
                    />

                </div> -->
                  </div>
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <span>B</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input
                        v-validate="'required'"
                        name="option 2"
                        placeholder="Option 2"
                        class="w-full"
                        v-model="taskLocal.options.option_2"
                        :color="validateForm ? 'success' : 'danger'"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="taskLocal.type != 'boolean'">
                    <div class="vx-col sm:w-1/4 w-full">
                      <span>C</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input
                        name="option 3"
                        placeholder="Option 3"
                        class="w-full"
                        v-model="taskLocal.options.option_3"
                        :color="validateForm ? 'success' : 'danger'"
                      />
                    </div>
                  </div>
                  <div class="vx-row mb-6" v-if="taskLocal.type != 'boolean'">
                    <div class="vx-col sm:w-1/4 w-full">
                      <span>D</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input
                        name="option 4"
                        placeholder="Option 4"
                        class="w-full"
                        v-model="taskLocal.options.option_4"
                        :color="validateForm ? 'success' : 'danger'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Answer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <v-select
                    :multiple="
                      taskLocal.type == 'multiple-select' ? true : false
                    "
                    :options="
                      taskLocal.type == 'boolean'
                        ? getTwoOptions()
                        : getAllOptions()
                    "
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-validate="'required'"
                    name="answer"
                    placeholder="Select correct answer"
                    class="w-full"
                    v-model="taskLocal.answer"
                    :color="validateForm ? 'success' : 'danger'"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DataProvider from "../../../services/data-provider";
import { bus } from "../../../main";

export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    item: {
      type: Object,
    },
  },
  created() {
    bus.$on("edit_question", (data, questions, item_data) => {
      console.log(data);

      if (data.type == "boolean") {
        this.taskLocal.answer = data.correct_answer;
        this.taskLocal.options.option_1 = data.correct_answer;
        this.taskLocal.options.option_2 = data.incorrect_answers[0];
      } else if (data.type == "single-select") {
        this.taskLocal.answer = data.correct_answer;
        this.taskLocal.options.option_1 = data.correct_answer;
        this.taskLocal.options.option_2 = data.incorrect_answers[0];
        this.taskLocal.options.option_3 = data.incorrect_answers[1];
        this.taskLocal.options.option_4 = data.incorrect_answers[2];
      } else {
        this.taskLocal.answer = data.correct_answer;
        for (let i = 0; i < data.correct_answer.length; i++) {
          this.taskLocal.options["option_" + (i + 1)] = data.correct_answer[i];
        }
        let start = data.correct_answer.length;
        for (let j = 0; j < start; j++) {
          this.taskLocal.options["option_" + (start + (j + 1))] =
            data.incorrect_answers[j];
        }
      }

      this.taskLocal.question = data.question;
      this.taskLocal.type = data.type;
      // this.taskLocal.correct_answer = data.correct_answer;
      // this.taskLocal.incorrect_answers = data.incorrect_answers;
      this.taskLocal.id = data.id;
      this.old_question = data.question;
      this.activePrompt = true;
      this.is_edit = true;
      this.all_questions = questions;
      this.item_data_temp = item_data;
      console.log(" this.taskLocal:", this.taskLocal);
    });
  },
  data() {
    return {
      activePrompt: false,
      is_edit: false,
      all_questions: [],
      item_data_temp: "", // store post data
      old_question: "", //store old queston for check while update
      taskLocal: {
        question: "",
        type: "",
        options: {
          option_1: "",
          option_2: "",
          option_3: "",
          option_4: "",
        },
        answer: "",
        correct_answer: [],
        incorrect_answers: [],
        id: "",
      },
    };
  },
  computed: {
    taskTags() {
      return this.$store.state.todo.taskTags;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.taskLocal.question != "" &&
        this.taskLocal.type != "" &&
        (this.taskLocal.type == "single-select" ||
        this.taskLocal.type == "multiple-select"
          ? this.taskLocal.options.option_1 != "" &&
            this.taskLocal.options.option_2 != ""
          : // this.taskLocal.options.option_3 != "" &&
            // this.taskLocal.options.option_4 != ""
            this.taskLocal.options.option_1 != "" &&
            this.taskLocal.options.option_2 != "") &&
        this.taskLocal.answer != "" &&
        (this.taskLocal.type == "multiple-select"
          ? this.taskLocal.answer.length >= 1
          : this.taskLocal.answer != "")
      );
    },
  },
  methods: {
    clearFields() {
      Object.assign(this.taskLocal, {
        question: "",
        type: "",
        answer: "",
        options: {
          option_1: "",
          option_2: "",
          option_3: "",
          option_4: "",
        },
        correct_answer: [],
        incorrect_answers: [],
      });
      this.is_edit = false;
      this.all_questions = [];
      this.old_question = "";
    },
    getTwoOptions() {
      let option = [
        (this.taskLocal.options.option_1 = "true"),
        (this.taskLocal.options.option_2 = "false"),
      ];
      this.taskLocal.options.option_3 = "";
      this.taskLocal.options.option_4 = "";
      return option;
    },
    getAllOptions(event) {
      console.log();
      let option = [
        this.taskLocal.options.option_1,
        this.taskLocal.options.option_2,
        this.taskLocal.options.option_3,
        this.taskLocal.options.option_4,
      ];
      if (
        this.taskLocal.type == "single-select" ||
        this.taskLocal.answer == ""
      ) {
        // console.log("in++++");
        let filter_op = option.filter((item) => {
          if (item == this.taskLocal.answer) {
          } else {
            return item;
          }
        });
        return filter_op;
      } else {
        if (this.taskLocal.answer) {
          const filteredArray = option.filter((x) => {
            return this.taskLocal.answer.indexOf(x) < 0;
          });
          console.log(filteredArray);
          return filteredArray;
        } else {
          return option;
        }
      }
    },
    addTodo() {
      // this.$vs.loading();
      console.log(this.taskLocal);
      if (this.is_edit == false) {
        let unique_id = this.generateUUID();
        this.taskLocal.id = unique_id;
      }
      if (this.taskLocal.type == "boolean") {
        // console.log(this.taskLocal.options["option_1"].toLowerCase())
        // console.log(this.taskLocal.options["option_2"].toLowerCase())
        this.taskLocal.options["option_1"] = this.taskLocal.options[
          "option_1"
        ].toLowerCase();
        this.taskLocal.options["option_2"] = this.taskLocal.options[
          "option_2"
        ].toLowerCase();
        this.taskLocal.correct_answer = this.taskLocal.answer;

        if (this.taskLocal.options["option_1"] != this.taskLocal.answer) {
          console.log(
            "wwww:",
            this.taskLocal.options["option_1"] != this.taskLocal.answer
          );
          this.taskLocal.incorrect_answers.push(
            this.taskLocal.options["option_1"]
          );
        } else {
          console.log(
            "wwww====:",
            this.taskLocal.options["option_1"] == this.taskLocal.answer
          );
          this.taskLocal.incorrect_answers.push(
            this.taskLocal.options["option_2"]
          );
        }
      } else if (this.taskLocal.type == "single-select") {
        this.taskLocal.correct_answer = this.taskLocal.answer;
        for (const property in this.taskLocal.options) {
          console.log(`${property}: ${this.taskLocal.options[property]}`);
          if (
            this.taskLocal.options[property] != this.taskLocal.answer &&
            this.taskLocal.options[property] !== "" &&
            this.taskLocal.options[property] != undefined
          ) {
            this.taskLocal.incorrect_answers.push(
              this.taskLocal.options[property]
            );
          }
        }
      } else {
        this.taskLocal.correct_answer = this.taskLocal.answer;
        let myArray = [];
        for (const property in this.taskLocal.options) {
          console.log(`${property}: ${this.taskLocal.options[property]}`);
          if (
            this.taskLocal.options[property] !== "" &&
            this.taskLocal.options[property] != undefined
          ) {
            myArray.push(this.taskLocal.options[property]);
          }
        }
        const filteredArray = myArray.filter((x) => {
          return this.taskLocal.answer.indexOf(x) < 0;
        });
        this.taskLocal.incorrect_answers = filteredArray;
      }
      console.log(this.taskLocal);
      let question_data = {
        question: this.taskLocal.question,
        type: this.taskLocal.type,
        correct_answer: this.taskLocal.correct_answer,
        incorrect_answers: this.taskLocal.incorrect_answers,
        id: this.taskLocal.id,
      };
      this.$validator.validateAll().then((result) => {
        console.log(result);
        if (result) {
          if (this.is_edit == false) {
            let category_name = this.item.category.split(" ").join("_");
            DataProvider.updateFirestoreCloudData(
              "/health_hacks_question/" + this.item.id + "/" + category_name,
              question_data
            ).then(
              (data) => {
                this.$vs.loading.close();
                console.log("Data:", data);
                this.$emit("reload_question_data");
                this.clearFields();
              },
              (err) => {
                this.$vs.loading.close();
                DataProvider.sendSentryErrorLog(err)
              }
            );
          } else {
            console.log("all_questions before", this.all_questions);
            console.log("this.taskLocal.id", this.taskLocal);
            let category_name = this.item_data_temp.category
              .split(" ")
              .join("_");
            if (this.taskLocal.type == "multiple-select") {
              this.taskLocal.correct_answer = this.taskLocal.correct_answer.filter(
                function (el) {
                  return el != null;
                }
              );
            }
            this.taskLocal.incorrect_answers = this.taskLocal.incorrect_answers.filter(
              function (el) {
                return el != null;
              }
            );

            let updated_q = this.all_questions.map((item) => {
              console.log("item", item);
              console.log("taskLocal", item.question == this.old_question);
              if (item.question == this.old_question) {
                item.question = this.taskLocal.question;
                item.correct_answer = this.taskLocal.correct_answer;
                item.incorrect_answers = this.taskLocal.incorrect_answers;
                item.type = this.taskLocal.type;
              }
            });
            console.log("this.all_questions", this.all_questions);
            DataProvider.updateFirestoreCloudData(
              "/health_hacks_question_all/" +
                this.item_data_temp.id +
                "/" +
                category_name,
              this.all_questions
            ).then(
              (data) => {
                console.log("Data:", data);
                this.$vs.loading.close();
                this.$emit("reload_question_data");
                this.clearFields();
              },
              (err) => {
                this.$vs.loading.close();
                DataProvider.sendSentryErrorLog(err)
              }
            );
          }
        }
      });
    },
    generateUUID() {
      var d = new Date().getTime();
      var uuid = "xxx4xyxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
  },
};
</script>
<style scoped>
</style>
